import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'wl-report-files',
  templateUrl: './report-files.component.html',
  styleUrls: ['./report-files.component.less'],
    standalone: false
})
export class ReportFilesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
